// extracted by mini-css-extract-plugin
export default {"countdown":"WeddingDate_countdown__v0HTh","timeBox":"WeddingDate_timeBox__yEvK9","dateNumbers":"WeddingDate_dateNumbers__0vd0C"};